module.exports = __webpack_public_path__ + "img/65.6.CODm.92c5b57a.png";